export enum WaypointStatus{
    PENDING = "PENDENTE", 
    COLLECTED = "RECOLHIDA", 
    SKIPED = "IGNORADA"
}